<template>
<div class="chapter">
<div class="inner_page">
<p class="p15"><img alt="img2.png" src="images/img2.png"/></p>
<p class="p14"><span class="t8"> </span></p>
<p class="p16"><span class="t9">Life has been known by a series of constants: violence, anger, drugs, sex, death, heartbreak, pain, fear, and, the most common, hunger. Always hunger. Not the kind that can be satisfied with food, but the kind born of circumstance. The kind that not only claws within a gut, but settles into a heart, consumes a mind. Deeper—encircles, penetrates the soul. Hunger for something more, something better, safer. Always just out of grasp—craving—starved.</span></p>
<p class="p16"><span class="t9">It’s part of me.</span></p>
<p class="p16"><span class="t9">Who I am.</span></p>
<p class="p16"><span class="t9">Born of blood and violence, hunger is my fate.</span></p>
<p class="p16"><span class="t9">Yet, the slightest things can change the directions of a life. An unplanned circumstance, random act—a connection—a chance event, like a lightning strike, fate is trumped.</span></p>
<p class="p16"><span class="t9">Jamie is my lightning strike.</span></p>
<p class="p16"><span class="t9"> </span></p>
<p class="p16"><span class="t9">Tek Cain</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008.vue?de644130